module.exports = __webpack_public_path__ + "img/config_totalAddedValue.738a44ea.jpg";